<template>
    <el-dialog
            class="popup"
            :width="windowWidth > 1200 ? '1170px' : '95%'"
            :append-to-body="true"
            :show-close="false"
            :visible="showAnswer">
        <button class="btn popup__close" @click.prevent="closeAnswer">
            <i class="el-icon-close"></i>
        </button>
        <div class="rules__section-name">{{ question.answer_title }}</div>
        <div class="rules__item">{{ question.answer_description }}</div>
    </el-dialog>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import {store} from "../../../store/faq";

    export default {
        name: "Answer",
        store,
        computed: {
            ...mapState([
                'question',
                'showAnswer'
            ]),
        },
        methods: {
            ...mapActions([
                'closeAnswer',
            ]),
        },
    }
</script>